// Video hotspot → modal-based video player. The MVP uses an HTML <video> in a modal.
// Future work: an in-scene textured plane for in-VR playback (see ROADMAP.md).

import type { VideoHotspot } from '../app/types';
import type { ModalRoot } from '../ui/modal';

export function openVideoModal(modal: ModalRoot, hotspot: VideoHotspot): void {
  if (hotspot.videoUrl) {
    const video = document.createElement('video');
    video.src = hotspot.videoUrl;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'auto';
    modal.open({
      id: `video:${hotspot.id}`,
      title: hotspot.label,
      bodyNode: video,
    });
    modal.onClose(() => {
      video.pause();
      video.src = '';
      video.load();
    });
    return;
  }
  // No video asset — render a friendly placeholder so the prototype never blanks.
  modal.open({
    id: `video:${hotspot.id}`,
    title: hotspot.label,
    bodyHtml: `
      <p style="margin-bottom:16px;">${escapeHtml(hotspot.description ?? 'Vídeo em produção. Substitua o arquivo em <code>public/assets/videos/</code> e atribua o <code>videoUrl</code> no hotspot.')}</p>
      <div style="width:100%;aspect-ratio:16/9;background:#111;border-radius:12px;display:flex;align-items:center;justify-content:center;color:var(--dim);font-size:13px;">
        Pré-visualização do vídeo aparece aqui
      </div>
    `,
    actions: [{ label: 'Fechar' }],
  });
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
